// Illustrative photography. Alt text describes the scene only and never
// claims the people or vehicles shown are Swift Move and Clean's own.
const photo = (file, width, height, alt) => ({
  src: `/images/${file}.webp`,
  width,
  height,
  alt,
});

export const PHOTO_LIBRARY = {
  heroSunset: photo('hero-sunset-move', 1267, 730, 'Illustration of movers loading furniture into a moving truck at sunset'),
  bannerSunset: photo('banner-sunset-loading', 1090, 730, 'Illustration of a mover guiding a wrapped dresser down a truck ramp at sunset'),
  residentialMoving: photo('residential-moving', 1284, 963, 'Illustration of movers carrying a sofa and boxes beside a moving truck outside a townhome'),
  packing: photo('packing-kitchen', 1284, 963, 'Illustration of two people wrapping dishes in bubble wrap while packing a kitchen'),
  residentialCleaning: photo('residential-cleaning', 1284, 647, 'Illustration of two cleaners wiping a kitchen counter and vacuuming an empty living room'),
  commercialCleaning: photo('commercial-cleaning', 1262, 946, 'Illustration of two cleaners washing the glass doors of a retail storefront'),

  chestCarry: photo('gallery-1', 627, 410, 'Illustration of two movers carrying a wooden chest past a suburban home at sunset'),
  storageUnloading: photo('gallery-2', 626, 410, 'Illustration of movers unloading boxes from a truck beside a row of storage units at dusk'),
  streetChest: photo('gallery-3', 368, 420, 'Illustration of two movers carrying a wooden chest down a tree-lined street'),
  brickBuilding: photo('gallery-4', 438, 420, 'Illustration of moving trucks parked in front of a brick building with a clock tower'),
  streetSunset: photo('gallery-5', 627, 405, 'Illustration of a quiet neighborhood street at golden hour'),
  storageTruck: photo('gallery-6', 626, 405, 'Illustration of a person loading boxes into a truck between rows of storage units'),

  dresserCarry: photo('dresser-carry', 1000, 520, 'Illustration of two movers carrying a large wooden dresser along a sidewalk at sunset'),
  dresserRamp: photo('dresser-ramp', 560, 480, 'Illustration of two movers sliding a wrapped dresser down a truck ramp'),
  boxesFragile: photo('boxes-fragile', 420, 500, 'Illustration of labeled kitchen and fragile boxes stacked on a hand truck'),
  paintingBoxes: photo('painting-boxes', 394, 460, 'Illustration of movers holding labeled boxes and a framed painting'),
  bubbleWrap: photo('bubble-wrap', 954, 480, 'Illustration of plates being wrapped in bubble wrap on a kitchen counter'),
  sinkCleaning: photo('sink-cleaning', 560, 642, 'Illustration of a cleaner spraying and wiping a kitchen sink and counter'),
  floorVacuum: photo('floor-vacuum', 520, 440, 'Illustration of a cleaner vacuuming a hardwood floor in an empty room'),
  storefrontSqueegee: photo('storefront-squeegee', 640, 480, 'Illustration of a cleaner washing a storefront window with a squeegee'),
  storefrontDoor: photo('storefront-door', 582, 440, 'Illustration of a cleaner wiping the handle of a glass storefront door'),
};

const pick = (...keys) => keys.map((key) => PHOTO_LIBRARY[key]);

// Hero background carousel on the homepage.
export const HERO_CAROUSEL = [
  PHOTO_LIBRARY.heroSunset.src,
  PHOTO_LIBRARY.residentialCleaning.src,
  PHOTO_LIBRARY.residentialMoving.src,
  PHOTO_LIBRARY.commercialCleaning.src,
  PHOTO_LIBRARY.packing.src,
  PHOTO_LIBRARY.bannerSunset.src,
];

// Photo strips shown under each page hero.
export const PAGE_STRIPS = {
  residentialMoving: {
    heading: 'Residential Moving in Pictures',
    photos: pick('chestCarry', 'dresserRamp', 'dresserCarry'),
  },
  commercialMoving: {
    heading: 'Commercial Moving in Pictures',
    photos: pick('brickBuilding', 'storageTruck', 'storageUnloading'),
  },
  movingSupport: {
    heading: 'Packing and Moving Support in Pictures',
    photos: pick('bubbleWrap', 'boxesFragile', 'paintingBoxes'),
  },
  residentialCleaning: {
    heading: 'House Cleaning in Pictures',
    photos: pick('sinkCleaning', 'floorVacuum', 'residentialCleaning'),
  },
  commercialCleaning: {
    heading: 'Office and Storefront Cleaning in Pictures',
    photos: pick('storefrontSqueegee', 'storefrontDoor', 'commercialCleaning'),
  },
  pricing: {
    heading: 'Moving and Cleaning, Made Simple',
    photos: pick('dresserCarry', 'bubbleWrap', 'floorVacuum'),
  },
  careers: {
    heading: 'The Work We Do',
    photos: pick('dresserRamp', 'storefrontSqueegee', 'streetChest'),
  },
  about: {
    heading: 'Serving Indiana Neighborhoods',
    photos: pick('storageUnloading', 'streetSunset', 'chestCarry'),
  },
  faq: {
    heading: 'Moving and Cleaning at a Glance',
    photos: pick('boxesFragile', 'sinkCleaning', 'chestCarry'),
  },
  reviews: {
    heading: 'Moves and Cleans Across Indiana',
    photos: pick('brickBuilding', 'floorVacuum', 'residentialMoving'),
  },
  contact: {
    heading: 'Ready When You Are',
    photos: pick('storageTruck', 'streetSunset', 'dresserRamp'),
  },
};
